import { render, staticRenderFns } from "./Tranformative.vue?vue&type=template&id=6e1b173d"
import script from "./Tranformative.vue?vue&type=script&lang=js"
export * from "./Tranformative.vue?vue&type=script&lang=js"
import style0 from "./Tranformative.vue?vue&type=style&index=0&id=6e1b173d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports